module.exports = __webpack_public_path__ + "media/theme/tutorial__itunes--4-cf1f08ad.png";